import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import logo from "./mohindralogo.png";
import { Detail, Icon } from "./CardParts";

const phone = "9811612627";
const website = "https://www.mohindramechanicalworks.com";
const websiteLabel = "www.mohindramechanicalworks.com";
const address = "RZ-73, Nursing Garden, near Khyala Village, New Delhi, Delhi 110018";
const mapUrl = "https://maps.app.goo.gl/MQAWE4NQXZwaKtkp6";
const whatsappMessage = "Hello Neha Khan (Mohindra Mechanical Works), I would like to enquire about your machines. Please share the machine details, specifications, price, and delivery information.";
const whatsappUrl = `https://wa.me/91${phone}?text=${encodeURIComponent(whatsappMessage)}`;
const contactName = "Ms. Neha Khan (Mohindra Mechanical Works)";
const contactEmail = "neha@mohindramechanicalworks.com";
const contactCompany = "Mohindra Mechanical Works";
const contactTitle = "Sales Executive";
const companyAbout = "Mohindra Mechanical Works is a trusted manufacturer and exporter of advanced industrial machinery in India.";
const facebookUrl = "https://www.facebook.com/mohindramechanicalworksdelhi/";
const instagramUrl = "https://www.instagram.com/mohindramechanical/";
const youtubeUrl = "https://www.youtube.com/@mohindramechanicalworks";
const getAndroidContactUrl = () => [
  "intent://contacts/people/#Intent",
  "action=android.intent.action.INSERT",
  "type=vnd.android.cursor.dir/contact",
  `S.name=${encodeURIComponent(contactName)}`,
  `S.phone=%2B91${phone}`,
  "i.phone_type=2",
  `S.secondary_phone=%2B91${phone}`,
  "i.secondary_phone_type=7",
  `S.email=${encodeURIComponent(contactEmail)}`,
  "i.email_type=3",
  `S.postal=${encodeURIComponent(address)}`,
  "i.postal_type=2",
  `S.company=${encodeURIComponent(contactCompany)}`,
  `S.job_title=${encodeURIComponent(contactTitle)}`,
  `S.browser_fallback_url=${encodeURIComponent(`${window.location.origin}${vcardUrl}`)}`,
  "end"
].join(";");
const vcardUrl = "/Neha-Khan-Mohindra.vcf";

const NehaKhanCard = () => {
  const [flipped, setFlipped] = useState(false);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const contactHref = isAndroid ? getAndroidContactUrl() : vcardUrl;

  return (
    <section className="card-stage person-card-block" aria-label="Neha Khan digital business card">
      <div className="platinum-card">
        <div className={`card-inner ${flipped ? "is-flipped" : ""}`}>
          <article className="card-face card-front">
            <section className="front-info">
              <p className="person-label">Ms.</p>
              <h1>Neha Khan</h1>
              <p className="role">Sales Executive</p>
              <div className="contact-details">
                <Detail icon="phone" href={`tel:+91${phone}`}>+91 {phone}</Detail>
                <Detail icon="email" href={`mailto:${contactEmail}`}>{contactEmail}</Detail>
                <Detail icon="web" href={website}>{websiteLabel}</Detail>
                <Detail icon="location" href={mapUrl}>{address}</Detail>
              </div>
            </section>

            <section className="front-brand">
              <div className="brand-lockup">
                <div className="round-logo"><img src={logo} alt="Mohindra Mechanical Works logo" /></div>
                <div>
                  <strong>Mohindra</strong>
                  <span>Mechanical Works</span>
                </div>
              </div>
              <div className="qr-tile website-qr">
                <QRCodeSVG value={website} size={92} level="M" />
                <small>Website</small>
              </div>
              <div className="angle-ribbon ribbon-one" aria-hidden="true" />
              <div className="angle-ribbon ribbon-two" aria-hidden="true" />
              <div className="angle-ribbon ribbon-three" aria-hidden="true" />
            </section>
          </article>

          <article className="card-face card-back">
            <section className="back-logo-panel">
              <div className="brand-lockup">
                <div className="round-logo"><img src={logo} alt="Mohindra Mechanical Works logo" /></div>
                <div>
                  <strong>Mohindra</strong>
                  <span>Mechanical Works</span>
                </div>
              </div>
              <div className="social-links" aria-label="Social media">
                <a className="facebook" href={facebookUrl} target="_blank" rel="noreferrer" aria-label="Facebook"><Icon name="facebook" /><span>Facebook</span></a>
                <a className="instagram" href={instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram"><Icon name="instagram" /><span>Instagram</span></a>
                <a className="youtube" href={youtubeUrl} target="_blank" rel="noreferrer" aria-label="YouTube"><Icon name="youtube" /><span>YouTube</span></a>
              </div>
            </section>
            <section className="back-center">
              <div className="qr-pair">
                <div className="qr-tile"><QRCodeSVG value={mapUrl} size={112} level="M" /><small>Location</small></div>
                <div className="qr-tile"><QRCodeSVG value={`tel:+91${phone}`} size={112} level="M" /><small>Number</small></div>
              </div>
              <p>{companyAbout}</p>
            </section>
          </article>
        </div>
      </div>

      <button className="flip-btn" onClick={() => setFlipped(value => !value)} aria-pressed={flipped}>
        {flipped ? "Show Front" : "Show Back"}
      </button>

      <nav className="quick-actions" aria-label="Neha Khan contact actions">
        <a href={contactHref} type="text/vcard">Add To Contacts</a>
        <a href={`tel:+91${phone}`}>Call Now</a>
        <a href={`mailto:${contactEmail}`}>Email Us</a>
        <a href={whatsappUrl} target="_blank" rel="noreferrer">WhatsApp Enquiry</a>
        <a href={website} target="_blank" rel="noreferrer">Website</a>
        <a href={mapUrl} target="_blank" rel="noreferrer">Visit Location</a>
        <a href="/brochure.pdf" target="_blank" rel="noreferrer">Brochure</a>
      </nav>
    </section>
  );
};

export default NehaKhanCard;
